import React from 'react';
import { Box } from '@beeline.com/bp-design-system';

interface ModalHeaderProps {
  children?: React.ReactNode;
}

export const ModalHeader = ({ children }: ModalHeaderProps) => {
  return (
    <Box pb={5} className="modal-header">
      {children}
    </Box>
  );
};
